module.exports = __webpack_public_path__ + "static/media/blog-post.2.c206db4f.md";